import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

/** Conteo de anomalías abiertas. Solo administradores ven este módulo. */
export function useOpenAnomalies() {
  const { isAdmin } = useAuth();

  return useQuery({
    queryKey: ["open-anomalies-count"],
    enabled: isAdmin,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("reservation_anomalies")
        .select("severity")
        .eq("status", "open");
      if (error) throw error;
      const rows = data ?? [];
      return {
        total: rows.length,
        critical: rows.filter((r) => r.severity === "critical").length,
        warning: rows.filter((r) => r.severity === "warning").length,
      };
    },
  });
}
